import React from 'react';
import { CompanyHeader } from '../CompanyHeader';
import { LicenseDisclaimer } from '../LicenseDisclaimer';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <CompanyHeader />
        
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Microsoft License Configuration Tool
          </h1>
          <p className="text-lg text-gray-600">
            Compare features across different Microsoft licensing plans
          </p>
        </div>

        {children}

        <LicenseDisclaimer />
      </div>
    </div>
  );
};